var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOui(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 251,
    viewBox: "0 0 251 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8007 72.2104L106.041 132.46L81.9106 170.89L31.0706 72.2104H64.8007Z",
    fill: "#29A063"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3806 103.17L31.0706 72.2104L88.4606 155.43L166.731 32.8304L187.601 62.6304L89.6406 217.57L11.3806 103.17Z",
    fill: "#B2E8C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M166.73 32.8304H200.47L220.86 62.8704L187.6 62.6304L166.73 32.8304Z",
    fill: "#29A063"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6406 217.57H121.891L220.861 62.8704L187.601 62.6304L89.6406 217.57Z",
    fill: "#72D09A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOui);
export default __webpack_public_path__ + "static/media/oui.1aec1abac7e215e5b23accaed88380d5.svg";
export { ForwardRef as ReactComponent };